import {SAVING_PLACEMENT_DO_NOT_CLOSE_WINDOW, UPLOADING_PLACEMENTS,} from "../BulkUploadConstant";
import {Modal} from "@cjdev-internal/visual-stack-x/Modal";
import {Text} from "@cjdev-internal/visual-stack-x/Text";
import {LoadingAnimation} from "@cjdev-internal/visual-stack-x/LoadingAnimation";
import {useBulkUploadContext} from "../../BulkUploadContext/BulkUploadContext";

const SavePlacementProcessing = () => {
    const {bulkUploadDetails} = useBulkUploadContext();
    return (
        <>
            <Modal height="126px" minHeight="126px" width="465px">
                <div style={{textAlign: "center"}}>
                    <LoadingAnimation loadingMessage={UPLOADING_PLACEMENTS}/>
                    <div style={{textAlign: "center"}}>
                        <Text size={13}
                              color="subdued">{bulkUploadDetails.successfulRows.length + bulkUploadDetails.failedRows.length} of {bulkUploadDetails.rows.length}</Text>
                    </div>
                    <div>
                        <Text size={13} color="subdued">{SAVING_PLACEMENT_DO_NOT_CLOSE_WINDOW}</Text>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default SavePlacementProcessing;